import "flatpickr/dist/themes/material_blue.css";
import "../../assets/scss/datatables.scss";

import * as messageAction from "../../store/message/action";
import {
  GET_FLOW_LOGIC,
  ADD_FLOW_LOGIC,
  DELETE_FLOW_LOGIC,
  GET_ALL_SELECT,
  GET_DT_SOURCE,
} from "../../helpers/url_api_constant";

import { AvField, AvForm } from "availity-reactstrap-validation";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  TabContent,
  TabPane,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import MessageDialog, {
  useModalShowMessage,
} from "../../components/Custom/MessageDialog";

import ConfirmDialog, {
  useConfirmDialog,
} from "../../components/Custom/ConfirmDialog";

import PropTypes, { number, objectOf } from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import Loading from "../../components/Custom/Loading";
import OverButton from "../../components/Custom/Overbutton";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Select from "react-select";
import Tooltip from "react-bootstrap/Tooltip";
import cellEditFactory from "react-bootstrap-table2-editor";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../helpers/api_helper";
import { withTranslation } from "react-i18next";
import { getPermission } from "../../helpers/auth_helper";
import Item from "antd/lib/list/Item";


function FlowLogic(props) {
  const dispatch = useDispatch();
  let history = useHistory();
  let { mode, pid } = useParams();

  const permission = getPermission();
  // console.log(mode);
  const searchObj = {
    COMMUNICATION_NAME2: "",
    FLOWSOURCE_GRP: "",
  };
  const createObj = {
    COMMUNICATION_NAME: "",
    FLOWSOURCE_GRP: "",
    FLOWSOURCEKEY_PID: "",
    FLOWSOURCEKEY_NAME: "",
    FLOWSOURCE1_PID: "",
    FLOWSOURCE1_NAME: "",
    FLOWSOURCE2_PID: "",
    FLOWSOURCE2_NAME: "",
    FLOWSOURCE3_PID: "",
    FLOWSOURCE3_NAME: "",
    FLOWSOURCE4_PID: "",
    FLOWSOURCE4_NAME: "",
    VARIANCE: "",
    USESOURCE_NAME: "",
    PRIORITY_FLAG: "",
    FLOWSOURCE_NO: "",
    LOGIC_STATUS: 1,
    STATUS_FLAG: null,
  };

  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [isLoading, setIsLoading] = useState(false);
  const [readonly, setReadonly] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [pageAdd, setPageAdd] = useState(false);
  const [userActionType, setUserActionType] = useState("");

  const [flagShowBySourceKey, setFlagShowBySourceKey] = useState(false);
  const [flagShowComSourceOne, setFlagShowComSourceOne] = useState(false);
  const [flagShowComSourceTwo, setFlagShowComSourceTwo] = useState(false);
  const [flagShowComSourceThree, setFlagShowComSourceThree] = useState(false);
  const [flagShowComSourceFour, setFlagShowComSourceFour] = useState(false);
  const [flagShowComSourceFive, setFlagShowComSourceFive] = useState(false);

  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();

  const [listCommunicationType, setListCommunicationType] = useState([]);
  const [listDataSourceType, setListDataSourceType] = useState([]);
  const [listUseDataSourceType, setListUseDataSourceType] = useState([]);
  const [listTargetSource, setListTargetSource] = useState([]);
  // DropDown
  const [dropDownCommuType, setDropDownCommuType] = useState(null);
  const [dropDownFlowSource, setDropDownFlowSource] = useState(null);
  const [dropDownSourceKey, setDropDownSourceKey] = useState(null);
  const [dropDownCompareOne, setDropDownCompareOne] = useState(null);
  const [dropDownCompareTwo, setDropDownCompareTwo] = useState(null);
  const [dropDownCompareThree, setDropDownCompareThree] = useState(null);
  const [dropDownCompareFour, setDropDownCompareFour] = useState(null);
  const [dropDownCompareFive, setDropDownCompareFive] = useState(null);
  const [dropDownTargetSource, setDropDownTargetSource] = useState(null);

  const [dropDownSearchCommunicationType, setDropDownSearchCommunicationType] = useState(null);
  const [dropDownSearchFlowSource, setDropDropDownSearchFlowSource] = useState(null);
  // DropDown

  // Handle Set Value DropDown //

  const handleSelectDropDownCommuType = selected => {
    setDropDownCommuType(selected);
  };

  const handleSelectDropDownFlowSource = selected => {
    setDropDownFlowSource(selected);
    // selectSource();
  };

  const handleSelectDropDownSourceKey = selected => {
    setDropDownSourceKey(selected);
  };

  const handleSelectDropDownCompareOne = selected => {
    setDropDownCompareOne(selected);
  };

  const handleSelectDropDownCompareTwo = selected => {
    setDropDownCompareTwo(selected);
  };

  const handleSelectDropDownCompareThree = selected => {
    setDropDownCompareThree(selected);
  };

  const handleSelectDropDownCompareFour = selected => {
    setDropDownCompareFour(selected);
  };

  const handleSelectDropDownCompareFive = selected => {
    setDropDownCompareFive(selected);
  };

  const handleSelectDropDownTargetSource = selected => {
    setDropDownTargetSource(selected);
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  // Handle Set Value DropDown //

  const listQualityPoint = [
    { label: "BCS1", value: "BCS1" },
    { label: "BCS2", value: "BCS2" },
    { label: "BCS3", value: "BCS3" },
    { label: "BCS4", value: "BCS4" },
    { label: "BCS5", value: "BCS5" },
    { label: "BCS6", value: "BCS6" },
    { label: "BCS7", value: "BCS7" },
  ];


  const listEnergyInput = [
    { label: "TPA", value: "TPA" },
    { label: "NG-Billing", value: "NG-Billing" },
    { label: "GDMR", value: "GDMR" },
    { label: "SCADA", value: "SCADA" },
    { label: "Manual", value: "Manual" },
    { label: "Calculate", value: "Calculate" },
  ];

  const listFlowSource = [
    { label: "0 Source", value: "0 Source" },
    { label: "1 Source", value: "1 Source" },
    // { label: "NG-Billing", value: "NG-Billing" },
    { label: "2 Source", value: "2 Source" },
    { label: "3 Source", value: "3 Source" },
    { label: "4 Source", value: "4 Source" },
  ];

  // const listSourceTypeDropDown = [
  //   { label: "TPA", value: "TPA" },
  //   { label: "Billing", value: "Billing" },
  //   // { label: "NG-Billing", value: "NG-Billing" },
  //   { label: "GDMR", value: "GDMR" },
  //   { label: "SCADA", value: "SCADA" },
  //   { label: "Nomination", value: "Nomination" },
  // ];

  // const listTargetSource = [
  //   { label: "TPA", value: "TPA" },
  //   { label: "Billing", value: "Billing" },
  //   // { label: "NG-Billing", value: "NG-Billing" },
  //   { label: "GDMR", value: "GDMR" },
  //   { label: "SCADA", value: "SCADA" },
  //   { label: "Nomination", value: "Nomination" },
  //   { label: "ค่าแตกต่างต่ำสุด", value: "ค่าแตกต่างต่ำสุด" },
  // ];

  // const [listSourceType, setListSourceType] = useState(listSourceTypeDropDown);

  //sort Column//
  const defaultSorted = [
    {
      dataField: "METER_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from}
      to {to}
      of {size}
      Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div className="d-sm-flex align-items-center justify-content-center">
        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        {permission.eFLC && (
          <>
            <OverButton
              onClick={() => {
                setReadonly(false);
                onEdit(row);
                setUserActionType("(Edit)");
              }}
              color="info"
              icon="far fa-edit"
              label="Edit"
            />
            <OverButton
              onClick={() => {
                onDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            />
          </>
        )}
      </div>
    );
  };
  // Action Button//

  const checkStatus = (cellContent, row) => {

    // if (row.LOGIC_STATUS == null) {
    //   cellContent = "null";
    // } else {
    //   cellContent = row.FLOWVOLUME;
    // }
    let color;

    if (row.LOGIC_STATUS == 1) {
      color = "#109600";
    } else if (row.LOGIC_STATUS == 2) {
      color = "#FCF400";
    } else {
      color = "#FF0001";
    }

    return (
      <div className="justify-content-between">
        <i
          className="mdi mdi-circle align-middle mb-2"
          style={{ color: color }}
        ></i>
      </div>
    );
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };



  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "3%",
        fontSize: "12px",
      },
      style: {
        width: "3%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
      // sort: true,
    },
    {
      dataField: "COMMUNICATION_NAME",
      text: "Communication",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "FLOWSOURCE_GRP",
      text: "Flow Source",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "FLOWSOURCEKEY_NAME",
      text: "Source Key",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "FLOWSOURCE1_NAME",
      text: "Compare Source 1",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "FLOWSOURCE2_NAME",
      text: "Compare Source 2",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "FLOWSOURCE3_NAME",
      text: "Compare Source 3",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "FLOWSOURCE4_NAME",
      text: "Compare Source 4",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
        fontSize: "12px",
      },
      sort: true,
    },
    // {
    //   dataField: "FLOWSOURCE5_NAME",
    //   text: "Compare Source 5",
    //   headerAlign: "center",
    //   editable: false,
    //   align: "center",
    //   headerStyle: {
    //     // backgroundColor: "#7E8EDA",
    //     width: "8%",
    //   },
    //   // sort: true,
    // },
    {
      dataField: "VARIANCE",
      text: "Variance (%)",
      headerAlign: "center",
      editable: false,
      align: "right",
      headerStyle: {
        width: "6%",
        fontSize: "12px",
      },
      style: {
        width: "6%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "USESOURCE_NAME",
      text: "Target Source",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "LOGIC_STATUS",
      formatter: checkStatus,
      text: "Status",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "PRIORITY_FLAG",
      text: "Priority",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "6%",
        fontSize: "12px",
      },
      style: {
        width: "6%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      formatter: ButtonAction,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "3%",
        fontSize: "12px",
      },
      style: {
        width: "3%",
        fontSize: "12px",
        paddingLeft: "0.7%",
        paddingRight: "0.5%"

      },
    },
  ];

  //headerColumn
  const addHeaderTable = () => {
    let thead = document
      .getElementById("flow-selection-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th colspan="4" style="border-color: #2a3042"></th><th colspan="3" style="text-align:center;background-color:#6478d7;color:#FFFFFF">Volume</th><th colspan="2" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Heating Value</th><th colspan="3" style="text-align:center;background-color:#4362f8;color:#FFFFFF">Energy</th>';
    thead.prepend(tr);
  };

  //onInit//
  useEffect(function () {
    resetSearch();
    resetModel();

    ///fixed header table
    let tableId = "flow-logic-table";
    let scrollY = 326;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  useEffect(function () {

    let COMMUNICATION_PID = dropDownCommuType != null ? dropDownCommuType.value : null;
    let COMMUNICATION_NAME = dropDownCommuType != null ? dropDownCommuType.label : null;

    let FLOWSOURCE_GRP = dropDownFlowSource != null ? dropDownFlowSource.value : null;

    let FLOWSOURCEKEY_PID = dropDownSourceKey != null ? dropDownSourceKey.value : null;
    let FLOWSOURCEKEY_NAME = dropDownSourceKey != null ? dropDownSourceKey.label : null;

    let FLOWSOURCE1_PID = dropDownCompareOne != null ? dropDownCompareOne.value : null;
    let FLOWSOURCE1_NAME = dropDownCompareOne != null ? dropDownCompareOne.label : null;

    let FLOWSOURCE2_PID = dropDownCompareTwo != null ? dropDownCompareTwo.value : null;
    let FLOWSOURCE2_NAME = dropDownCompareTwo != null ? dropDownCompareTwo.label : null;

    let FLOWSOURCE3_PID = dropDownCompareThree != null ? dropDownCompareThree.value : null;
    let FLOWSOURCE3_NAME = dropDownCompareThree != null ? dropDownCompareThree.label : null;

    let FLOWSOURCE4_PID = dropDownCompareFour != null ? dropDownCompareFour.value : null;
    let FLOWSOURCE4_NAME = dropDownCompareFour != null ? dropDownCompareFour.label : null;

    let FLOWSOURCE5_PID = dropDownCompareFive != null ? dropDownCompareFive.value : null;
    let FLOWSOURCE5_NAME = dropDownCompareFive != null ? dropDownCompareFive.label : null;

    let USESOURCE_PID = dropDownTargetSource != null ? dropDownTargetSource.value : null;
    let USESOURCE_NAME = dropDownTargetSource != null ? dropDownTargetSource.label : null;

    setCreateModel(preVent => ({
      ...preVent,
      COMMUNICATION_PID: COMMUNICATION_PID,
      COMMUNICATION_NAME: COMMUNICATION_NAME,

      FLOWSOURCE_GRP: FLOWSOURCE_GRP,

      FLOWSOURCEKEY_PID: FLOWSOURCEKEY_PID,
      FLOWSOURCEKEY_NAME: FLOWSOURCEKEY_NAME,
      FLOWSOURCE1_PID: FLOWSOURCE1_PID,
      FLOWSOURCE1_NAME: FLOWSOURCE1_NAME,
      FLOWSOURCE2_PID: FLOWSOURCE2_PID,
      FLOWSOURCE2_NAME: FLOWSOURCE2_NAME,
      FLOWSOURCE3_PID: FLOWSOURCE3_PID,
      FLOWSOURCE3_NAME: FLOWSOURCE3_NAME,
      FLOWSOURCE4_PID: FLOWSOURCE4_PID,
      FLOWSOURCE4_NAME: FLOWSOURCE4_NAME,
      FLOWSOURCE5_PID: FLOWSOURCE5_PID,
      FLOWSOURCE5_NAME: FLOWSOURCE5_NAME,
      USESOURCE_PID: USESOURCE_PID,
      USESOURCE_NAME: USESOURCE_NAME
    }));

    CutDropDown(FLOWSOURCEKEY_PID, FLOWSOURCE1_PID, FLOWSOURCE2_PID, FLOWSOURCE3_PID, FLOWSOURCE4_PID, FLOWSOURCE5_PID);

  }, [dropDownCommuType, dropDownFlowSource, dropDownSourceKey, dropDownCompareOne, dropDownCompareTwo, dropDownCompareThree,
    dropDownCompareFour, dropDownCompareFive, dropDownTargetSource]);


  useEffect(function () {

    let COMMUNICATION_NAME2 = dropDownSearchCommunicationType != null ? dropDownSearchCommunicationType.label : null;
    let FLOWSOURCE_GRP = dropDownSearchFlowSource != null ? dropDownSearchFlowSource.label : null;

    setSearchModel(preVent => ({
      ...preVent, COMMUNICATION_NAME2: COMMUNICATION_NAME2, FLOWSOURCE_GRP: FLOWSOURCE_GRP
    }));
  }, [dropDownSearchCommunicationType, dropDownSearchFlowSource]);

  //Function CURL 
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    setDropDownSearchCommunicationType(null);
    setDropDropDownSearchFlowSource(null);
  };

  const resetModel = () => {
    setCreateModel(createObj);
    setDropDownCommuType(listCommunicationType[0]);
    setDropDownFlowSource(listFlowSource[0]);
    setDropDownSourceKey(listDataSourceType.find((item) => {
      return item.label == "Nomination"
    }));
    setDropDownCompareOne(null);
    setDropDownCompareTwo(null);
    setDropDownCompareThree(null);
    setDropDownCompareFour(null);
    setDropDownCompareFive(null);
    setDropDownTargetSource(listTargetSource[0]);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {
    // console.log(row);
    setCreateModel(row);
    setDropDownCommuType(listCommunicationType.find(obj => obj.value == row.COMMUNICATION_PID));
    setDropDownFlowSource(listFlowSource.find(obj => obj.value == row.FLOWSOURCE_GRP));
    setDropDownSourceKey(listDataSourceType.find(obj => obj.value == row.FLOWSOURCEKEY_PID));
    setDropDownCompareOne(listDataSourceType.find(obj => obj.value == row.FLOWSOURCE1_PID));
    setDropDownCompareTwo(listDataSourceType.find(obj => obj.value == row.FLOWSOURCE2_PID));
    setDropDownCompareThree(listDataSourceType.find(obj => obj.value == row.FLOWSOURCE3_PID));
    setDropDownCompareFour(listDataSourceType.find(obj => obj.value == row.FLOWSOURCE4_PID));
    setDropDownCompareFive(listDataSourceType.find(obj => obj.value == row.FLOWSOURCE5_PID));
    setDropDownTargetSource(listTargetSource.find(obj => obj.value == row.USESOURCE_PID));

    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    let element = document.querySelectorAll(".form-require")
    element.forEach(el => {
      if (el.classList.contains("is-invalid")) {
        el.classList.remove('is-invalid')
      }
    }
    );
    if (createModel.VARIANCE == "" || createModel.VARIANCE == null || createModel.VARIANCE == undefined) {
      bResult = false;
    }

    if (createModel.PRIORITY_FLAG == "" || createModel.PRIORITY_FLAG == null || createModel.PRIORITY_FLAG == undefined) {
      bResult = false;
    }

    if (dropDownFlowSource.label == "0 Source") {

      if (createModel.FLOWSOURCEKEY_PID == "" || createModel.FLOWSOURCEKEY_PID == null || createModel.FLOWSOURCEKEY_PID == undefined) {
        document.getElementById("FLOWSOURCEKEY_PID").classList.add('is-invalid');
        bResult = false;
      }

    } else if (dropDownFlowSource.label == "1 Source") {

      if (createModel.FLOWSOURCEKEY_PID == "" || createModel.FLOWSOURCEKEY_PID == null || createModel.FLOWSOURCEKEY_PID == undefined) {
        document.getElementById("FLOWSOURCEKEY_PID").classList.add('is-invalid');
        bResult = false;
      }
      // if (createModel.FLOWSOURCE1_PID == "" || createModel.FLOWSOURCE1_PID == null || createModel.FLOWSOURCE1_PID == undefined) {
      //   document.getElementById("FLOWSOURCE1_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
    } else if (dropDownFlowSource.label == "2 Source") {

      if (createModel.FLOWSOURCEKEY_PID == "" || createModel.FLOWSOURCEKEY_PID == null || createModel.FLOWSOURCEKEY_PID == undefined) {
        document.getElementById("FLOWSOURCEKEY_PID").classList.add('is-invalid');
        bResult = false;
      }
      // if (createModel.FLOWSOURCE1_PID == "" || createModel.FLOWSOURCE1_PID == null || createModel.FLOWSOURCE1_PID == undefined) {
      //   document.getElementById("FLOWSOURCE1_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
      // if (createModel.FLOWSOURCE2_PID == "" || createModel.FLOWSOURCE2_PID == null || createModel.FLOWSOURCE2_PID == undefined) {
      //   document.getElementById("FLOWSOURCE2_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
    } else if (dropDownFlowSource.label == "3 Source") {

      if (createModel.FLOWSOURCEKEY_PID == "" || createModel.FLOWSOURCEKEY_PID == null || createModel.FLOWSOURCEKEY_PID == undefined) {
        document.getElementById("FLOWSOURCEKEY_PID").classList.add('is-invalid');
        bResult = false;
      }
      // if (createModel.FLOWSOURCE1_PID == "" || createModel.FLOWSOURCE1_PID == null || createModel.FLOWSOURCE1_PID == undefined) {
      //   document.getElementById("FLOWSOURCE1_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
      // if (createModel.FLOWSOURCE2_PID == "" || createModel.FLOWSOURCE2_PID == null || createModel.FLOWSOURCE2_PID == undefined) {
      //   document.getElementById("FLOWSOURCE2_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
      // if (createModel.FLOWSOURCE3_PID == "" || createModel.FLOWSOURCE3_PID == null || createModel.FLOWSOURCE3_PID == undefined) {
      //   document.getElementById("FLOWSOURCE3_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
    } else if (dropDownFlowSource.label == "4 Source") {

      if (createModel.FLOWSOURCEKEY_PID == "" || createModel.FLOWSOURCEKEY_PID == null || createModel.FLOWSOURCEKEY_PID == undefined) {
        document.getElementById("FLOWSOURCEKEY_PID").classList.add('is-invalid');
        bResult = false;
      }
      // if (createModel.FLOWSOURCE1_PID == "" || createModel.FLOWSOURCE1_PID == null || createModel.FLOWSOURCE1_PID == undefined) {
      //   document.getElementById("FLOWSOURCE1_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
      // if (createModel.FLOWSOURCE2_PID == "" || createModel.FLOWSOURCE2_PID == null || createModel.FLOWSOURCE2_PID == undefined) {
      //   document.getElementById("FLOWSOURCE2_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
      // if (createModel.FLOWSOURCE3_PID == "" || createModel.FLOWSOURCE3_PID == null || createModel.FLOWSOURCE3_PID == undefined) {
      //   document.getElementById("FLOWSOURCE3_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
      // if (createModel.FLOWSOURCE4_PID == "" || createModel.FLOWSOURCE4_PID == null || createModel.FLOWSOURCE4_PID == undefined) {
      //   document.getElementById("FLOWSOURCE4_PID").classList.add('is-invalid');
      //   bResult = false;
      // }
    } else {

    }

    return bResult;
  };

  const compare = (a, b) => {
    // console.log(a, b);
    if (a.ALIAS_NAME < b.ALIAS_NAME) {
      return -1;
    }
    if (a.ALIAS_NAME > b.ALIAS_NAME) {
      return 1;
    }
    return 0;
  }

  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      let optionCommu = await post(GET_ALL_SELECT);

      setListCommunicationType(optionCommu.data.ctCommuList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));

      let optionSourceType = await post(GET_DT_SOURCE, { IS_TARGET_SOURCE: true, IS_VIRTUAL_METER: true });
      setListTargetSource(optionSourceType.data.dtSourceList.map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setListDataSourceType(optionSourceType.data.dtSourceList.map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })).slice(1));

      let res = await post(GET_FLOW_LOGIC, searchData);
      res.data.FlowLogicList = res.data.FlowLogicList.sort(function (a, b) {
        if (a.COMMUNICATION_NAME === b.COMMUNICATION_NAME) {
          if (a.FLOWSOURCE_GRP === b.FLOWSOURCE_GRP) {
            return (a.PRIORITY_FLAG < b.PRIORITY_FLAG) ? -1 : (a.PRIORITY_FLAG > b.PRIORITY_FLAG) ? 1 : 0;
          } else {
            return (a.FLOWSOURCE_GRP > b.FLOWSOURCE_GRP) ? -1 : 1;
          }
        } else {
          return (a.COMMUNICATION_NAME < b.COMMUNICATION_NAME) ? -1 : 1;
        }
      }).map(obj => ({ ...obj, VARIANCE: obj.VARIANCE * 100 }))

      // console.log(res);
      setModelDeviceList(res.data.FlowLogicList);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  // useEffect(function () {
  //   // console.log(listCommunicationType);
  //   console.log(listDataSourceType);
  //   // listCommunicationType, 
  // }, [listDataSourceType]);


  const saveData = async () => {
    // console.log(createModel);
    if (validateForm()) {
      let tempCreateModel = createModel;
      if (tempCreateModel.FLOWSOURCE_GRP == "0 Source") {
        tempCreateModel.FLOWSOURCE_NO = 0
        tempCreateModel.FLOWSOURCE1_PID = null
        tempCreateModel.FLOWSOURCE1_NAME = null
        tempCreateModel.FLOWSOURCE2_PID = null
        tempCreateModel.FLOWSOURCE2_NAME = null
        tempCreateModel.FLOWSOURCE3_PID = null
        tempCreateModel.FLOWSOURCE3_NAME = null
        tempCreateModel.FLOWSOURCE4_PID = null
        tempCreateModel.FLOWSOURCE4_NAME = null
      } else if (tempCreateModel.FLOWSOURCE_GRP == "1 Source") {
        tempCreateModel.FLOWSOURCE_NO = 1
        tempCreateModel.FLOWSOURCE2_PID = null
        tempCreateModel.FLOWSOURCE2_NAME = null
        tempCreateModel.FLOWSOURCE3_PID = null
        tempCreateModel.FLOWSOURCE3_NAME = null
        tempCreateModel.FLOWSOURCE4_PID = null
        tempCreateModel.FLOWSOURCE4_NAME = null
      } else if (tempCreateModel.FLOWSOURCE_GRP == "2 Source") {
        tempCreateModel.FLOWSOURCE_NO = 2
        tempCreateModel.FLOWSOURCE3_PID = null
        tempCreateModel.FLOWSOURCE3_NAME = null
        tempCreateModel.FLOWSOURCE4_PID = null
        tempCreateModel.FLOWSOURCE4_NAME = null
      } else if (tempCreateModel.FLOWSOURCE_GRP == "3 Source") {
        tempCreateModel.FLOWSOURCE_NO = 3
        tempCreateModel.FLOWSOURCE4_PID = null
        tempCreateModel.FLOWSOURCE4_NAME = null
      } else {
        tempCreateModel.FLOWSOURCE_NO = 4
        tempCreateModel = createModel;
      }

      tempCreateModel.VARIANCE = createModel.VARIANCE / 100;

      // console.log(tempCreateModel.VARIANCE);
      tempCreateModel.STATUS_FLAG = null
      setIsLoading(true);
      try {
        let res = await post(ADD_FLOW_LOGIC, tempCreateModel);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_FLOW_LOGIC, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete Success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.resultDescription);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };

  const selectSource = () => {
    // console.log(dropDownFlowSource);
    if (dropDownFlowSource.value == "0 Source") {
      // setFlagShowBySource(true);
      let set = listSourceType.slice(4);
      setListSourceType(set);
      setDropDownSourceKey(set);
    } else if (dropDownFlowSource.value == "1 Source") {
      setFlagShowComSourceOne(true);
      // let set = listSourceType.slice(4);
      // setListSourceType(set);
      // setDropDownSourceKey(set);
    }
  };

  const CutDropDown = (Selec1, Selec2, Selec3, Selec4, Selec5, Selec6) => {
    // console.log(Selec1, Selec2, Selec3, Selec4, Selec5, Selec6);
    let result = [];
    for (let i = 0; i < listDataSourceType.length; i++) { //listDataSourceType[i].value != Selec1 &&
      if (listDataSourceType[i].value != Selec2 && listDataSourceType[i].value != Selec3
        && listDataSourceType[i].value != Selec4 && listDataSourceType[i].value != Selec5 && listDataSourceType[i].value != Selec6) {
        result.push(listDataSourceType[i]);
      }
    }
    // console.log(listDataSourceType);
    if (dropDownFlowSource != null && dropDownFlowSource.label == "0 Source" && listDataSourceType.length > 0) {
      result = [listDataSourceType[0]];
      // console.log(result);
    }

    setListUseDataSourceType(result);
    //   .filter((row) => {
    //   return row.label != "Virtual Calculation"
    // }));
  };

  const resetValueDropDown = () => {
    setDropDownFlowSource(listFlowSource[0]);
    setDropDownSourceKey(listDataSourceType[0]);
    setDropDownCompareOne(null);
    setDropDownCompareTwo(null);
    setDropDownCompareThree(null);
    setDropDownCompareFour(null);
    setDropDownCompareFive(null);
    setDropDownTargetSource(listTargetSource[0]);
  };

  const handleSelectDropDownSearchCommunicationType = selected => {
    setDropDownSearchCommunicationType(selected);
  };

  const handleSelectDropDownSearchFlowSource = selected => {
    setDropDropDownSearchFlowSource(selected);
  };

  //Function CURL
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Flow Logic")}
                      {/* ({mode}) */}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link
                            to="#"
                            style={{ color: "#556ee6" }}
                          >
                            Master Data Setting
                          </Link>
                        </li>
                        <li className="breadcrumb-item active"> Flow Logic </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="4">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Communication
                            </Label>
                            <Col sm={8}>
                              <Select
                                placeholder="All"
                                isClearable={true}
                                value={dropDownSearchCommunicationType}
                                onChange={
                                  handleSelectDropDownSearchCommunicationType
                                }
                                options={listCommunicationType}
                                classNamePrefix="select2-selection"
                                styles={SelectStyle}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Flow Source
                            </Label>
                            <Col sm={8}>
                              <Select
                                placeholder="All"
                                isClearable={true}
                                value={dropDownSearchFlowSource}
                                onChange={
                                  handleSelectDropDownSearchFlowSource
                                }
                                options={listFlowSource}
                                classNamePrefix="select2-selection"
                                styles={SelectStyle}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="row">
                            <div className="d-grid gap-2 d-md-block">
                              <Button
                                color="info"
                                className="mt-0"
                                onClick={() => onSearch()}>
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button
                                color="warning"
                                className="mt-0 ms-2"
                                onClick={() => resetSearch()}>
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row className="mb-0 mt-1">
                        <Col sm="3">
                          <div className="d-grid gap-0 d-md-block">
                            {permission.eFLC && (
                              <Button
                                onClick={() => onAdd()}
                                // className="btn-rounded"
                                color="success"
                                className="mt-2 mb-1"
                              >
                                <i className="fas fa-plus"></i>
                                &nbsp; Add
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-2">
                        <hr />
                      </Row>
                      <Row className="mt-0">
                        {/* <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        > */}
                          {/* <TabPane tabId="1"> */}
                            <Col sm="12">
                              <div>
                                <BootstrapTable
                                  id="flow-logic-table"
                                  keyField="PID"
                                  data={modelDeviceList}
                                  columns={columns}
                                  // defaultSorted={defaultSorted}
                                  headerClasses="header-style"
                                  rowStyle={rowStyleFontWhite}
                                  pagination={paginationFactory(options)}
                                // hover
                                // striped
                                // hover
                                // condensed

                                // if(rowIndex % 2 == 0){

                                // } else {

                                // }
                                />
                              </div>
                            </Col>
                          {/* </TabPane>
                        </TabContent> */}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Flow Logic {userActionType}
          </h5>
        </div>
        <div className="modal-body">

          <CardBody>
            <AvForm className="needs-validation">
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Communication
                  </Label>
                  <Col sm={8}>
                    <Select
                      // placeholder="All"
                      // isClearable={true}
                      isDisabled={readonly}
                      value={dropDownCommuType}
                      onChange={handleSelectDropDownCommuType}
                      options={listCommunicationType}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Flow Source
                  </Label>
                  <Col sm={8}>
                    <Select
                      // placeholder="All"
                      // isClearable={true
                      isDisabled={readonly}
                      value={dropDownFlowSource}
                      onChange={handleSelectDropDownFlowSource}
                      options={listFlowSource}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Source Key
                  </Label>
                  <Col sm={8}>
                    <Select
                      id="FLOWSOURCEKEY_PID"
                      placeholder="( Blank )"
                      isClearable={true}
                      isDisabled={readonly}
                      value={dropDownSourceKey}
                      onChange={handleSelectDropDownSourceKey}
                      options={listDataSourceType.filter((row) => {
                        if (dropDownFlowSource.value == "0 Source") {
                          return row.label == "Nomination"
                        }
                        return true
                      })
                      }
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </Col>
                </FormGroup>
              </Row>
              {/* || dropDownFlowSource.value == "2 Source" || dropDownFlowSource.value == "3 Source" 
              || dropDownFlowSource.value == "4 Source" */}
              {dropDownFlowSource != null && dropDownFlowSource.value != "0 Source" && (
                <Row>
                  <FormGroup className="row mb-3">
                    <Label
                      className="col-sm-3 col-form-label text-center">
                      <span style={{ color: "#FF0E03" }}> </span>
                      Compare Source 1
                    </Label>
                    <Col sm={8}>
                      <Select
                        id="FLOWSOURCE1_PID"
                        placeholder="( Blank )"
                        isClearable={true}
                        isDisabled={readonly}
                        value={dropDownCompareOne}
                        onChange={handleSelectDropDownCompareOne}
                        options={listUseDataSourceType}
                        classNamePrefix="select2-selection"
                        styles={SelectStyle}
                      />
                    </Col>
                  </FormGroup>
                </Row>
              )}

              {dropDownFlowSource != null && dropDownFlowSource.value != "0 Source" && dropDownFlowSource.value != "1 Source" && (

                <Row>
                  <FormGroup className="row mb-3">
                    <Label
                      className="col-sm-3 col-form-label text-center">
                      <span style={{ color: "#FF0E03" }}> </span>
                      Compare Source 2
                    </Label>
                    <Col sm={8}>
                      <Select
                        id="FLOWSOURCE2_PID"
                        placeholder="( Blank )"
                        isClearable={true}
                        isDisabled={readonly}
                        value={dropDownCompareTwo}
                        onChange={handleSelectDropDownCompareTwo}
                        options={listUseDataSourceType}
                        classNamePrefix="select2-selection"
                        styles={SelectStyle}
                      />
                    </Col>
                  </FormGroup>
                </Row>
              )}

              {dropDownFlowSource != null && dropDownFlowSource.value != "0 Source" && dropDownFlowSource.value != "1 Source" && dropDownFlowSource.value != "2 Source" && (

                <Row>
                  <FormGroup className="row mb-3">
                    <Label
                      className="col-sm-3 col-form-label text-center">
                      <span style={{ color: "#FF0E03" }}> </span>
                      Compare Source 3
                    </Label>
                    <Col sm={8}>
                      <Select
                        id="FLOWSOURCE3_PID"
                        placeholder="( Blank )"
                        isClearable={true}
                        isDisabled={readonly}
                        value={dropDownCompareThree}
                        onChange={handleSelectDropDownCompareThree}
                        options={listUseDataSourceType}
                        classNamePrefix="select2-selection"
                        styles={SelectStyle}
                      />
                    </Col>
                  </FormGroup>
                </Row>
              )}

              {dropDownFlowSource != null && dropDownFlowSource.value != "0 Source" && dropDownFlowSource.value != "1 Source" && dropDownFlowSource.value != "2 Source"
                && dropDownFlowSource.value != "3 Source" && (
                  <Row>
                    <FormGroup className="row mb-3">
                      <Label
                        className="col-sm-3 col-form-label text-center">
                        <span style={{ color: "#FF0E03" }}> </span>
                        Compare Source 4
                      </Label>
                      <Col sm={8}>
                        <Select
                          id="FLOWSOURCE4_PID"
                          placeholder="( Blank )"
                          isClearable={true}
                          isDisabled={readonly}
                          value={dropDownCompareFour}
                          onChange={handleSelectDropDownCompareFour}
                          options={listUseDataSourceType}
                          classNamePrefix="select2-selection"
                          styles={SelectStyle}
                        />
                      </Col>
                    </FormGroup>
                  </Row>
                )}

              {dropDownFlowSource != null && dropDownFlowSource.value != "0 Source" && dropDownFlowSource.value != "1 Source" && dropDownFlowSource.value != "2 Source"
                && dropDownFlowSource.value != "3 Source" && dropDownFlowSource.value != "4 Source" && (
                  <Row>
                    <FormGroup className="row mb-3">
                      <Label
                        className="col-sm-3 col-form-label text-center">
                        <span style={{ color: "#FF0E03" }}> </span>
                        Compare Source 5
                      </Label>
                      <Col sm={8}>
                        <Select
                          id="FLOWSOURCE5_PID"
                          placeholder="( Blank )"
                          isClearable={true}
                          isDisabled={readonly}
                          value={dropDownCompareFive}
                          onChange={handleSelectDropDownCompareFive}
                          options={listUseDataSourceType}
                          classNamePrefix="select2-selection"
                          styles={SelectStyle}
                        />
                      </Col>
                    </FormGroup>
                  </Row>
                )}

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Variance
                  </Label>
                  <Col sm={7}>
                    <AvField
                      // readOnly={readonly}
                      disabled={readonly}
                      name="VARIANCE"
                      type="number"
                      errorMessage="Enter Variance"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={(e) => setCreateModel(
                        {
                          ...createModel,
                          VARIANCE: e.target.value
                        })
                      }
                      value={createModel.VARIANCE}
                    />
                  </Col>
                  <Col sm={1}>
                    <InputGroupAddon addonType="append">
                      <InputGroupText>%</InputGroupText>
                      {/* style={{border:"solid 1px #FFFFFF"}} */}
                    </InputGroupAddon>
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Target Source
                  </Label>
                  <Col sm={8}>
                    <Select
                      placeholder="Blank"
                      isClearable={true}
                      isDisabled={readonly}
                      value={dropDownTargetSource}
                      onChange={handleSelectDropDownTargetSource}
                      options={listTargetSource}
                      // .filter((row) => {
                      //   return row.label != "Virtual Calculation"
                      // })
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Status
                  </Label>
                  <Col sm={1}>
                    <div className="form-check mt-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios1"
                        value="1"
                        // defaultChecked
                        checked={createModel.LOGIC_STATUS == 1}
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            LOGIC_STATUS: e.target.value,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleRadios1"
                      >
                        <i
                          className="mdi mdi-circle align-middle"
                          style={{ color: "#109600" }}
                        ></i>
                      </label>
                    </div>
                  </Col>

                  <Col sm={1}>
                    <div className="form-check mt-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios2"
                        value="2"
                        // defaultChecked
                        checked={createModel.LOGIC_STATUS == 2}
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            LOGIC_STATUS: e.target.value,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleRadios2"
                      >
                        <i
                          className="mdi mdi-circle align-middle"
                          style={{ color: "#FCF400" }}
                        ></i>
                      </label>
                    </div>
                  </Col>

                  <Col sm={1}>
                    <div className="form-check mt-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios3"
                        value="3"
                        // defaultChecked
                        checked={createModel.LOGIC_STATUS == 3}
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            LOGIC_STATUS: e.target.value,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleRadios3"
                      >
                        <i
                          className="mdi mdi-circle align-middle"
                          style={{ color: "#FF0001" }}
                        ></i>
                      </label>
                    </div>
                  </Col>
                </FormGroup>
              </Row>
              {/* {createModel.PRIORITY_FLAG} */}
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Priority
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // readOnly={readonly}
                      disabled={readonly}
                      name="PRIORITY_FLAG"
                      min={1}
                      type="number"
                      errorMessage="Enter Priority ( Priority > 0 )"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      // // style={{ border: "solid 1px #FFFFFF" }}
                      onChange={(e) => setCreateModel(
                        {
                          ...createModel,
                          PRIORITY_FLAG: e.target.value
                        })
                      }
                      value={createModel.PRIORITY_FLAG}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }

                {/* {!readonly &&
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={() => resetValueDropDown()}
                  >
                    <i className="bx bx-reset"></i> Reset Flow Source
                  </button>
                } */}
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>

              </div>
            </AvForm>
          </CardBody>
          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      <Loading show={isLoading} />

      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />

      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />

    </React.Fragment >
  );
}

FlowLogic.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ FlowLogic }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FlowLogic));
